module.exports = __webpack_public_path__ + "static/media/Stevens-Apparel-Color-R.03b5a61c.png";